import { FieldProps } from "../../../../../InputFieldsController/InputFieldsController.utils";

/**
 * Utility functions for FieldValidator
 */
export interface FieldValidatorProps {
  selectedField: FieldProps;
  updateField: (partial: Partial<FieldProps>) => void;
}


/**
 * Add validation or remove validation rule of type "required".
 */
export const toggleRequiredValidation = (field: FieldProps): FieldProps => {
  const current = field.validation || [];
  const hasRequired = current.some((v) => v.type === "required");

  return {
    ...field,
    validation: hasRequired
      ? current.filter((v) => v.type !== "required")
      : [
          ...current,
          { type: "required", message: `${field.label} is required` },
        ],
  };
};

export const getRegexValidation = (field: FieldProps): string => {
  const regexRule = field.validation?.find((v) => v.type === "regex");
  return regexRule?.pattern ?? "";
};

export const setRegexValidation = (
  field: FieldProps,
  pattern: string
): FieldProps => {
  const cleaned = (field.validation || []).filter((v) => v.type !== "regex");

  if (!pattern.trim()) {
    return { ...field, validation: cleaned }; // Remove if empty
  }

  return {
    ...field,
    validation: [
      ...cleaned,
      {
        type: "regex",
        pattern: pattern,
        message: "Invalid format",
      },
    ],
  };
};

export const getValidationMessage = (field: FieldProps): string => {
  const regexRule = field.validation?.find((v) => v.type === "regex");
  return regexRule?.message ?? "";
};

/**
 * Updates the message of the regex validation rule in a given field.
 *
 * @param field - The field whose validation rules to update.
 * @param message - The new validation message for the regex rule.
 * @returns A new FieldProps object with the updated message.
 */
export const setValidationMessage = (
  field: FieldProps,
  message: string
): FieldProps => {
  const validations = field.validation || [];

  const updatedValidations = validations.map((v) => {
    if (v.type === "regex") {
      return { ...v, message };
    }
    return v;
  });

  return {
    ...field,
    validation: updatedValidations,
  };
};
